/* MM places v1.5 (2026-11-03, Jullian). assets/mm-places.js
   v1.5 (Kevin, 3 Nov: make the MapTiler backup as good as it can be, for free): when Google search is
   off (or Enter is pressed without a pick), both search boxes now also ask:
   - Photon (photon.komoot.io, OpenStreetMap) when the text has a house number. Its exact house
     ("14 Elm Grove, Brighton", "1600 Pennsylvania Ave, Washington") goes first when MapTiler has no
     exact match of its own. 1.5 s time limit, else MapTiler's answer as before.
   - postcodes.io (UK, free, no key) for a full postcode anywhere in the text (to the postcode's
     own spot, about 15 homes) and for part postcodes ("SW1A", "BN2", "SW1A 1").
   - Dublin Eircodes (D01 to D24, D6W, alone or full) open that Dublin district, not Germany.
   Nothing from Google is used or stored. Anonymous log, page "msearch" (mm-steps, the hub funnel table): the kind of
   search (address, postcode, part postcode, Eircode, place), which source gave the picked line and
   its position, and whether the visitor then dragged the map (a sign the spot was off). No text typed
   is ever sent. Leave page "msearch" rows out of funnel counts. Off switch: window.MM_XS_OFF = true.
   v1.4 (3 Nov audit, Kevin: fix the search): both search boxes put real towns before shops and
   houses, and the visitor's own country (then the UK, Ireland and Europe) before far-away towns of the
   same name. "Ashford, Kent" gave KFC and a kebab shop; now Ashford (Kent) is first. "Gosport" gave
   Indiana; now Gosport, UK. Also Bath (was Banjul), Windsor (was Ontario), Cobh, Tenby, Big Ben.
   When MapTiler's answer has no town and no landmark of that name, it is asked once more without
   shops. Landmarks and streets named exactly as typed keep MapTiler's order (Eiffel Tower, Times
   Square). Outside Ireland the starting point Dublin is no longer used as the search centre: MapTiler
   uses the visitor's own area. Off switch: window.MM_RANK_OFF = true.
   v1.3 (Kevin 20:44, 'I click the first option, Jerusalem, it does not bring me centred'): the
   homepage search did not load this file, so it offered MapTiler's plain "Jerusalem" (900 m west
   of the dome). Now the file loads on every page, both search boxes list "Jerusalem Old City"
   first and drop the plain city "Jerusalem" (within 15 km), and any hand-off to the designer for
   Jerusalem (homepage pick, Recent list, Enter, ?mmq=Jerusalem) opens the 40 cm model centred on
   the Dome of the Rock. The suggestion itself also points at that exact centre.
   v1.2.1 (Kevin 19:33, 'make it the very centre point'): the search opens exactly on the middle of
   the Dome of the Rock (centre of OSM way 291836699: 31.778081, 35.235359), 9 m from v1.2's point.
   v1.2: Kevin chose version C (18:55): houses inside the walls 6 m, so the walls, the dome and the
   churches stand out. 19:01: the search opens the model centred on the Dome of the Rock (every
   size then has the dome in the middle), green ground under every olive tree, more groves.
   v1.1: picking the suggestion opens the model framed on the walls (40 cm, zoom 1.3, the whole
   walled city just fits), and the real parks and green belt outside the walls are kept.
   v1.0 notes:
   Kevin, 1 Nov: Jerusalem renders were "worthless" (a commenter) and too busy. Decided with Kevin:
   "Jerusalem, the Old City" is drawn as a calm heritage model, the same in the designer and in
   the ready-made product. It is the first suggestion when someone types "Jerusalem".
   What changes, only inside 1.1 km of the Dome of the Rock:
   - Houses inside the walls: real footprints, even 6 m (v1.2), flat roofs.
   - Outside the walls: modern buildings, roads, paths, parks and rail left out. The main churches,
     tombs and gates stay. Olive groves are added in the valleys and on the Mount of Olives.
   - The Temple Mount "forest" is replaced by a few lines of trees.
   - Natural Colour: the ground is stone-coloured, with green only in the olive groves and lawns.
   - Domes (OSM roof:shape=dome) are drawn as domes, in thin rings, on any building in that area.
   - Everything kept stays where it really is. Terrain is real.
   How: no change to the designer (assets/mm-configurator.js). This file wraps window.fetch and
   rewrites the map data answers for that area before the designer reads them. Same answer for
   the same question every time, so the designer's caches stay right.
   Also: a "Jerusalem Old City" suggestion at the top of the search (opens the framed 40 cm model when
   chosen), and "Edition: Old City heritage model" on the cart line so the print is made from
   our own file (not Mini Skyline). Overture and land cover are not asked for that area.
   Check: window.MM_BUILDS.places = "v1.3". Off switch: window.MM_PLACES_OFF = true before load. */
(function () {
  'use strict';
  if (window.__mmPlaces || window.MM_PLACES_OFF || !window.fetch) return;
  window.__mmPlaces = 1;
  (window.MM_BUILDS = window.MM_BUILDS || {}).places = 'v1.5';

  var D2R = Math.PI / 180;

  /* ------------------------------ the place ------------------------------ */
  var P = {
    id: 'jerusalem-old-city',
    name: 'Jerusalem Old City',
    ctx: 'Heritage model with the Dome of the Rock',
    edition: 'Old City heritage model',
    lat: 31.77804, lon: 35.23544,          /* Dome of the Rock: the middle of the 40 cm model */
    areaM: 1100,                           /* the rules apply inside this circle */
    sizeCm: 40,
    /* Shown when what is typed is the start of one of these (3+ letters for Jerusalem, 5+ for the
       rest), or starts with one of them. */
    names: ['jerusalem', 'jerusalem old city', 'old city jerusalem', 'old city of jerusalem', 'yerushalayim',
            'al quds', 'al-quds', 'dome of the rock', 'temple mount', 'via dolorosa', 'holy sepulchre',
            'church of the holy sepulchre', 'mount of olives', 'gethsemane', 'western wall', 'wailing wall'],
    /* Where the suggestion opens: 40 cm centred on the Dome of the Rock (v1.2, Kevin 19:01). The walled
       city fills the west half, the Kidron and the Mount of Olives the east half, and a smaller size
       keeps the dome in the middle. */
    frame: { lat: 31.778081, lon: 35.235359, zoom: 1 },
    greenOut: true,                        /* keep the real parks and green outside the walls */
    calmH: 6,                              /* houses inside the walls, metres (v1.2, Kevin chose C) */
    partH: 16,                             /* untagged building parts inside the walls */
    wallH: 12                              /* city walls with no height */
  };

  /* Test only: settings from this browser's storage (key mmPlacesOpt). Nobody else has it. */
  try {
    var OPT = JSON.parse(window.localStorage.getItem('mmPlacesOpt') || 'null');
    if (OPT) {
      if (OPT.calmH) P.calmH = +OPT.calmH;
      if (OPT.greenOut != null) P.greenOut = !!OPT.greenOut;
    }
  } catch (eO) {}

  /* The Old City wall line (OSM relation 5862586, simplified to 2.5 m). */
  var OC = [[35.22758,31.776657],[35.227503,31.776595],[35.227574,31.776528],[35.227644,31.776586],[35.227747,31.776508],[35.227658,31.776394],[35.227825,31.776289],[35.227753,31.775875],[35.227642,31.775883],[35.227618,31.775624],[35.22779,31.775595],[35.227857,31.77554],[35.22781,31.775419],[35.227759,31.774535],[35.227664,31.774534],[35.22766,31.774405],[35.227725,31.774416],[35.227713,31.773921],[35.227786,31.773908],[35.227817,31.773495],[35.227739,31.773494],[35.227742,31.773358],[35.227806,31.773359],[35.2278,31.773087],[35.22774,31.773087],[35.227742,31.772911],[35.229503,31.772898],[35.229742,31.772823],[35.230773,31.772935],[35.230772,31.772966],[35.231011,31.773026],[35.231003,31.77306],[35.231499,31.773154],[35.231483,31.773233],[35.232293,31.773404],[35.23234,31.773362],[35.232427,31.773436],[35.23238,31.773479],[35.23242,31.773833],[35.232459,31.773913],[35.232517,31.773913],[35.232535,31.774013],[35.233241,31.774283],[35.233557,31.774747],[35.235767,31.775046],[35.235672,31.775582],[35.235771,31.775593],[35.235759,31.775672],[35.235843,31.775681],[35.235797,31.775843],[35.237555,31.776082],[35.236955,31.780974],[35.236918,31.781381],[35.236999,31.781391],[35.236982,31.781533],[35.236931,31.781529],[35.236914,31.781703],[35.236964,31.781709],[35.236928,31.78197],[35.236965,31.78197],[35.236907,31.782264],[35.236953,31.782267],[35.236944,31.782362],[35.236895,31.782359],[35.236807,31.782862],[35.236847,31.782861],[35.236839,31.78293],[35.236795,31.782925],[35.236686,31.783641],[35.236776,31.783651],[35.236759,31.783752],[35.236654,31.783739],[35.236659,31.783693],[35.236318,31.783629],[35.236306,31.783671],[35.236225,31.783657],[35.236227,31.78362],[35.235839,31.783565],[35.235848,31.78354],[35.235445,31.783448],[35.235137,31.783383],[35.235125,31.78342],[35.235017,31.783393],[35.23503,31.783353],[35.234933,31.783327],[35.234972,31.783237],[35.234694,31.783202],[35.234687,31.783235],[35.234521,31.783196],[35.234521,31.78315],[35.233739,31.782979],[35.233725,31.783022],[35.233611,31.782996],[35.233626,31.782947],[35.233061,31.782816],[35.233045,31.782862],[35.232924,31.782847],[35.232926,31.782763],[35.232487,31.782683],[35.232472,31.782535],[35.232177,31.782489],[35.231864,31.782508],[35.231792,31.78258],[35.231637,31.782555],[35.231589,31.782585],[35.2313,31.782491],[35.231251,31.782425],[35.23105,31.78231],[35.231087,31.78227],[35.230952,31.782181],[35.230921,31.782214],[35.230846,31.782165],[35.230904,31.782097],[35.230745,31.781977],[35.230771,31.78194],[35.230558,31.781784],[35.230496,31.781843],[35.230391,31.781763],[35.230432,31.781724],[35.230276,31.781606],[35.230233,31.781647],[35.230134,31.781572],[35.230196,31.781513],[35.229897,31.781289],[35.229808,31.781363],[35.2295,31.781176],[35.229568,31.781111],[35.229465,31.781022],[35.229496,31.780984],[35.22856,31.780282],[35.228517,31.780301],[35.228397,31.780217],[35.228425,31.780181],[35.228124,31.779961],[35.228095,31.779989],[35.228048,31.779957],[35.228077,31.77992],[35.22775,31.779661],[35.227458,31.779963],[35.22688,31.779603],[35.22683,31.779646],[35.226068,31.779234],[35.226008,31.779308],[35.225857,31.77922],[35.226141,31.778914],[35.22569,31.778414],[35.22584,31.778307],[35.225826,31.778178],[35.225913,31.778144],[35.225883,31.778066],[35.22758,31.776657]];

  /* Outside the walls, only these stay (OSM ids, w = way, r = relation). */
  var KEEP = {
    w616186088: { height: '16' },                                         // Damascus Gate
    w137729554: { height: '15', 'roof:shape': 'flat' },                   // Church of All Nations, Gethsemane
    w280347366: { height: '16', 'roof:shape': 'flat' },                   // Church of Mary Magdalene
    w280345343: { height: '12', 'roof:shape': 'dome', 'roof:height': '4' },// Dominus Flevit
    w156839219: { height: '9', 'roof:shape': 'dome', 'roof:height': '3' }, // Chapel of the Ascension
    w280346241: { height: '8' },                                          // Tomb of the Virgin Mary
    w280346237: { height: '10' },                                         // St Stephen's Church
    w137729556: { height: '20', 'roof:shape': 'pyramidal', 'roof:height': '7' }, // Tomb of Absalom
    w288284733: { height: '9', 'roof:shape': 'pyramidal', 'roof:height': '3' },  // Tomb of Zacharias
    w288284732: { height: '6' },                                          // Tomb of the Sons of Hezir
    w376137590: { height: '16', 'roof:shape': 'flat' },                   // St Peter in Gallicantu
    w256278896: { height: '14' },                                         // Cenacle (Room of the Last Supper)
    w161058945: { height: '12' }, w161058978: { height: '12' },          // David's Tomb
    w161058936: { height: '10' },                                         // Armenian Monastery of St Saviour
    r3925223: { height: '22', 'roof:shape': 'flat' },                     // Dormition Abbey
    w1545824085: { height: '26', 'roof:height': '7' },                    // Dormition domes
    w1553751244: { height: '24', 'roof:height': '5' },
    w1553979108: { height: '24', 'roof:height': '5' }
  };
  /* Inside the walls: corrected or completed tags. */
  var FIX = {
    w4709536: { height: '12', 'roof:shape': 'flat' },                    // Dome of the Rock: the octagon
    w291836699: { height: '21', 'roof:shape': 'flat', _dome: { top: 35, h: 14 } }, // Dome of the Rock: drum, then the dome
    w280309331: { height: '18', 'roof:shape': 'flat' },                   // Al-Aqsa
    w291844838: { height: '32', 'roof:shape': 'dome', 'roof:height': '9' },// Al-Aqsa dome
    w45081545: { height: '16' },                                          // Hurva Synagogue (OSM says 3)
    w1022672085: { height: '18' },                                        // Church of the Holy Sepulchre
    w1022663497: { height: '20', 'roof:height': '5' },                    // Holy Sepulchre, east dome
    w29268902: { height: '16' },                                          // Church of the Redeemer
    r136164: { height: '16' },                                            // Tower of David
    w126864879: { height: '16' }                                          // St Anne
  };
  var DROP = { r19253751: 1 };   /* "Dome of the Rock" site relation tagged as a building: a slab over the platform */

  /* Olive groves (landuse=orchard: trees in rows) and tree lines on the Temple Mount. Ours. */
  function sq(pts) { return pts.concat([pts[0]]); }
  function circle(lat, lon, rM, n) {
    var out = [], kx = 111320 * Math.cos(lat * Math.PI / 180);
    for (var i = 0; i <= n; i++) {
      var a = (i % n) / n * 2 * Math.PI;
      out.push([lon + rM * Math.cos(a) / kx, lat + rM * Math.sin(a) / 110540]);
    }
    return out;
  }
  var EXTRA = [
    /* Stone-coloured ground over the whole area: without it the hills outside the walls come out as
       lawn in Natural Colour (no buildings and no land cover there any more). */
    { id: -100, tags: { landuse: 'brownfield', name: 'Judean hills' }, ring: circle(P.lat, P.lon, P.areaM, 48) },
    /* Hidden inside the Dome of the Rock's drum. Tells the designer this crop has woodland, so it
       does not fill the Temple Mount with woods from the map tiles. */
    { id: -99, tags: { natural: 'scrub' }, ring: circle(31.778025, 35.235295, 2, 6) },
    { id: -101, tags: { landuse: 'orchard', crop: 'olives', name: 'Mount of Olives and Gethsemane' },
      ring: sq([[35.23850,31.78400],[35.24400,31.78480],[35.24520,31.78000],[35.24500,31.77520],[35.24250,31.77220],[35.23950,31.77280],[35.23860,31.77650]]) },
    { id: -104, tags: { landuse: 'orchard', crop: 'olives', name: 'Kidron Valley' },
      ring: sq([[35.23680,31.77600],[35.23920,31.77580],[35.23980,31.77120],[35.23800,31.76900],[35.23620,31.77050]]) },
    { id: -105, tags: { landuse: 'orchard', crop: 'olives', name: 'Hinnom Valley' },
      ring: sq([[35.22780,31.77120],[35.22880,31.77060],[35.23060,31.77010],[35.23120,31.76960],[35.22980,31.76950],[35.22800,31.77010],[35.22720,31.77080]]) },
    { id: -107, tags: { landuse: 'orchard', crop: 'olives' },
      ring: sq([[35.23830,31.78260],[35.23960,31.78330],[35.24000,31.78230],[35.23880,31.78190]]) },
    { id: -108, tags: { landuse: 'orchard', crop: 'olives', name: 'Hinnom Valley west' },
      ring: sq([[35.22400,31.77700],[35.22550,31.77720],[35.22620,31.77350],[35.22500,31.77120],[35.22380,31.77300]]) },
    /* v1.2: more groves on the bare slopes (Kevin: no harm in more greenery). */
    { id: -109, tags: { landuse: 'orchard', crop: 'olives', name: 'City of David slope' },
      ring: sq([[35.23200,31.77250],[35.23600,31.77260],[35.23660,31.76820],[35.23350,31.76700],[35.23100,31.76900]]) },
    { id: -110, tags: { landuse: 'orchard', crop: 'olives', name: 'Mount Zion south slope' },
      ring: sq([[35.22700,31.77200],[35.23050,31.77180],[35.23150,31.76980],[35.22850,31.76880],[35.22600,31.77000]]) },
    { id: -111, tags: { landuse: 'orchard', crop: 'olives', name: 'Mount of Olives south' },
      ring: sq([[35.24000,31.77080],[35.24550,31.77150],[35.24650,31.76800],[35.24200,31.76700],[35.23950,31.76850]]) },
    { id: -112, tags: { landuse: 'orchard', crop: 'olives', name: 'North of the walls' },
      ring: sq([[35.22950,31.78520],[35.23700,31.78560],[35.23800,31.78850],[35.23050,31.78900]]) },
    { id: -113, tags: { landuse: 'orchard', crop: 'olives', name: 'West of the walls' },
      ring: sq([[35.22250,31.78150],[35.22520,31.78130],[35.22560,31.77800],[35.22300,31.77760]]) },
    { id: -201, tags: { natural: 'tree_row' }, line: [[35.23490,31.78040],[35.23660,31.78040]] },
    { id: -202, tags: { natural: 'tree_row' }, line: [[35.23660,31.77990],[35.23660,31.77800]] },
    { id: -203, tags: { natural: 'tree_row' }, line: [[35.23470,31.77980],[35.23470,31.77850]] },
    { id: -204, tags: { natural: 'tree_row' }, line: [[35.23480,31.77700],[35.23640,31.77700]] },
    { id: -205, tags: { natural: 'tree_row' }, line: [[35.23520,31.78010],[35.23640,31.78010]] },
    { id: -206, tags: { natural: 'tree_row' }, line: [[35.23630,31.77940],[35.23630,31.77830]] },
    { id: -207, tags: { natural: 'tree_row' }, line: [[35.23500,31.77930],[35.23500,31.77870]] }
  ];
  /* Olive groves as single trees about 15 m apart on the stony ground, not green fields: an orchard
     polygon paints the ground green and packs its trees into a solid block at this scale. Each tree
     is a half-metre tree row (the designer puts one tree on it). Same trees every time. */
  (function () {
    var trees = [], ky = 110540, kx = 111320 * Math.cos(31.778 * D2R), st = 15;
    EXTRA = EXTRA.filter(function (x) {
      if (x.tags.landuse !== 'orchard') return true;
      var r = x.ring, s = Infinity, n = -Infinity, w = Infinity, e = -Infinity, c = 0;
      r.forEach(function (p) { s = Math.min(s, p[1]); n = Math.max(n, p[1]); w = Math.min(w, p[0]); e = Math.max(e, p[0]); });
      for (var yi = 0; s + (yi + 0.5) * st / ky < n; yi++) {
        for (var xi = 0; w + (xi + 0.5) * st / kx < e; xi++) {
          var h = Math.sin((yi + 1) * 12.9898 + (xi + 1) * 78.233 + x.id) * 43758.5453;
          var jx = (h - Math.floor(h) - 0.5) * 5, jy = ((h * 7.13) - Math.floor(h * 7.13) - 0.5) * 5;
          var lon = w + ((xi + 0.5) * st + jx) / kx, lat = s + ((yi + 0.5) * st + jy) / ky;
          if (!inRing(lon, lat, r)) continue;
          /* Thinner towards the edge of each grove and a third missing overall, so it reads as old
             groves on terraces, not a planted block. */
          var dm = Infinity;
          for (var ei = 0; ei + 1 < r.length; ei++) {
            var ax = (r[ei][0] - lon) * kx, ay = (r[ei][1] - lat) * ky, bx = (r[ei + 1][0] - lon) * kx, by = (r[ei + 1][1] - lat) * ky;
            var dx = bx - ax, dy = by - ay, L2 = dx * dx + dy * dy, tt = L2 ? Math.max(0, Math.min(1, -(ax * dx + ay * dy) / L2)) : 0;
            dm = Math.min(dm, Math.hypot(ax + tt * dx, ay + tt * dy));
          }
          var h2 = Math.sin((xi + 3) * 39.3468 + (yi + 5) * 11.135 + x.id * 3.7) * 24634.6345;
          if (h2 - Math.floor(h2) > 0.66 * Math.min(1, dm / 70)) continue;
          trees.push({ id: x.id * 100000 - (++c), tags: { natural: 'tree_row', species: 'Olea europaea' },
                       line: [[lon, lat], [lon + 0.5 / kx, lat]] });
          /* v1.2: green ground under each tree, 11 m round, so the groves read as green terraces,
             not trees on bare sand. A park with no trees of its own. */
          trees.push({ id: x.id * 100000 - 50000 - c, tags: { leisure: 'park', 'mm:grove': 'ground' },
                       ring: circle(lat, lon, 11, 8) });
        }
      }
      return false;
    });
    EXTRA = EXTRA.concat(trees);
  })();

  /* ------------------------------ geometry ------------------------------- */
  function distM(lat, lon) {
    var dy = (lat - P.lat) * 110540, dx = (lon - P.lon) * 111320 * Math.cos(P.lat * D2R);
    return Math.sqrt(dx * dx + dy * dy);
  }
  function inRing(lon, lat, r) {
    var c = false;
    for (var i = 0, j = r.length - 1; i < r.length; j = i++) {
      var a = r[i], b = r[j];
      if (((a[1] > lat) !== (b[1] > lat)) && lon < (b[0] - a[0]) * (lat - a[1]) / (b[1] - a[1]) + a[0]) c = !c;
    }
    return c;
  }
  function inWalls(c) { return inRing(c[0], c[1], OC); }
  function anyIn(e) {
    var g = ptsOf(e);
    for (var i = 0; i < g.length; i++) if (distM(g[i].lat, g[i].lon) <= P.areaM) return true;
    return false;
  }
  function ptsOf(e) {
    if (e.geometry && e.geometry.length) return e.geometry;
    var out = [];
    (e.members || []).forEach(function (m) {
      if (m.geometry && (m.role === 'outer' || !m.role)) for (var i = 0; i < m.geometry.length; i++) out.push(m.geometry[i]);
    });
    return out;
  }
  function centre(e) {
    if (e.center) return [e.center.lon, e.center.lat];
    if (e.type === 'node') return [e.lon, e.lat];
    var g = ptsOf(e), n = g.length;
    if (!n) return null;
    if (n > 3 && g[0].lat === g[n - 1].lat && g[0].lon === g[n - 1].lon) n--;
    var sx = 0, sy = 0;
    for (var i = 0; i < n; i++) { sx += g[i].lon; sy += g[i].lat; }
    return [sx / n, sy / n];
  }
  function bboxOf(q) {
    var m = /\((-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)\)/.exec(q);
    return m ? { s: +m[1], w: +m[2], n: +m[3], e: +m[4] } : null;
  }
  function boxNearArea(b) {
    var la = Math.max(b.s, Math.min(P.lat, b.n)), lo = Math.max(b.w, Math.min(P.lon, b.e));
    return distM(la, lo) <= P.areaM;
  }
  function boxHits(b, pts) {
    var s = Infinity, n = -Infinity, w = Infinity, e = -Infinity;
    for (var i = 0; i < pts.length; i++) {
      var p = pts[i];
      if (p[1] < s) s = p[1]; if (p[1] > n) n = p[1]; if (p[0] < w) w = p[0]; if (p[0] > e) e = p[0];
    }
    return s <= b.n && n >= b.s && w <= b.e && e >= b.w;
  }

  /* --------------- a tiny Overpass reader, for our own shapes ------------ */
  function statements(q) {
    var out = [], re = /(node|way|relation|nwr)((?:\[[^\]]*\])+)\((-?[\d.]+),(-?[\d.]+),(-?[\d.]+),(-?[\d.]+)\)/g, m;
    while ((m = re.exec(q))) {
      var f = [], fr = /\[\s*(!?)"([^"]+)"\s*(?:(!=|!~|=|~)\s*"([^"]*)")?\s*\]/g, k;
      while ((k = fr.exec(m[2]))) f.push({ not: !!k[1], key: k[2], op: k[3] || '', val: k[4] });
      out.push({ type: m[1], f: f, b: { s: +m[3], w: +m[4], n: +m[5], e: +m[6] } });
    }
    return out;
  }
  function tagsMatch(t, f) {
    for (var i = 0; i < f.length; i++) {
      var c = f[i], v = t[c.key], ok;
      if (!c.op) ok = c.not ? v == null : v != null;
      else if (c.op === '=') ok = v === c.val;
      else if (c.op === '!=') ok = v !== c.val;
      else if (c.op === '~') ok = v != null && new RegExp(c.val).test(v);
      else ok = v == null || !new RegExp(c.val).test(v);
      if (!ok) return false;
    }
    return true;
  }
  function geomEl(id, tags, pts) {
    return { type: 'way', id: id, tags: tags, geometry: pts.map(function (p) { return { lat: p[1], lon: p[0] }; }) };
  }
  function extrasFor(q) {
    var st = statements(q), out = [];
    EXTRA.forEach(function (x) {
      var pts = x.ring || x.line;
      for (var i = 0; i < st.length; i++) {
        if ((st[i].type === 'way' || st[i].type === 'nwr') && tagsMatch(x.tags, st[i].f) && boxHits(st[i].b, pts)) {
          out.push(geomEl(x.id, x.tags, pts));
          return;
        }
      }
    });
    return out;
  }

  /* -------------------------------- domes -------------------------------- */
  /* A dome as thin stacked rings, each one a building from the ground up, so together they make the
     dome over the walls. 9 rings: under 0.4 mm a step on the 40 cm model. */
  var RINGS = 9, SIDES = 22;
  function domeRings(e, wallTop, top, kind) {
    var g = ptsOf(e), n = g.length;
    if (n > 3 && g[0].lat === g[n - 1].lat && g[0].lon === g[n - 1].lon) n--;
    if (n < 3 || !(top > wallTop)) return [];
    var ky = 110540, kx = 111320 * Math.cos(g[0].lat * D2R);
    var A = 0, cx = 0, cy = 0, i;
    for (i = 0; i < n; i++) {
      var a = g[i], b = g[(i + 1) % n];
      var ax = a.lon * kx, ay = a.lat * ky, bx = b.lon * kx, by = b.lat * ky, cr = ax * by - bx * ay;
      A += cr; cx += (ax + bx) * cr; cy += (ay + by) * cr;
    }
    if (Math.abs(A) < 1e-6) return [];
    A /= 2; cx /= 6 * A; cy /= 6 * A;
    var R = Infinity;                          /* the widest circle that fits the footprint */
    for (i = 0; i < n; i++) {
      var p = g[i], q = g[(i + 1) % n];
      var px = p.lon * kx - cx, py = p.lat * ky - cy, qx = q.lon * kx - cx, qy = q.lat * ky - cy;
      var dx = qx - px, dy = qy - py, L2 = dx * dx + dy * dy, t = L2 ? Math.max(0, Math.min(1, -(px * dx + py * dy) / L2)) : 0;
      R = Math.min(R, Math.hypot(px + t * dx, py + t * dy));
    }
    R = Math.min(R, Math.sqrt(Math.abs(A) / Math.PI));
    if (!(R > 1)) return [];
    var hgt = top - wallTop, out = [], base = (e.type === 'relation' ? 1e12 : 0) + e.id * 16;
    for (var k = 0; k < RINGS; k++) {
      var f = (k + 0.5) / RINGS;
      var rk = kind === 'onion'
        ? R * (f < 0.35 ? 1 + 0.25 * Math.sin(f / 0.35 * Math.PI / 2) : 1.25 * Math.cos((f - 0.35) / 0.65 * Math.PI / 2))
        : R * Math.sqrt(Math.max(0, 1 - f * f));
      if (rk < 0.6) continue;
      var ring = [];
      for (var s = 0; s <= SIDES; s++) {
        var ang = (s % SIDES) / SIDES * 2 * Math.PI;
        ring.push([(cx + rk * Math.cos(ang)) / kx, (cy + rk * Math.sin(ang)) / ky]);
      }
      out.push(geomEl(-(base + k + 1), { building: 'yes', height: String(+(wallTop + hgt * (k + 1) / RINGS).toFixed(2)),
        'roof:shape': 'flat', 'mm:dome': P.id }, ring));
    }
    return out;
  }
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : null; }
  /* Turns a dome-tagged building or part into walls plus rings. Returns the rings. */
  function domeOf(e) {
    var t = e.tags, shape = t['roof:shape'];
    var spec = t._dome;
    if (spec) { delete t._dome; return domeRings(e, num(t.height) || 0, spec.top, 'dome'); }
    if (shape !== 'dome' && shape !== 'onion') return [];
    var top = num(t.height);
    if (top == null) return [];
    var rh = num(t['roof:height']);
    var rings0 = domeRings(e, 0, 1, shape);      /* only to learn the radius */
    if (rh == null) rh = rings0.length ? Math.min(top * 0.5, 8) : 0;
    if (!(rh > 0.5)) return [];
    var wallTop = Math.max(num(t.min_height) || 0, top - rh);
    t.height = String(wallTop);
    t['roof:shape'] = 'flat';
    delete t['roof:height'];
    return domeRings(e, wallTop, top, shape);
  }

  /* ------------------------------- the rules ----------------------------- */
  function key(e) { return e.type.charAt(0) + e.id; }
  var HOLY = /^(church|chapel|cathedral|basilica|mosque|synagogue|religious|temple|shrine|monastery|wall)$/;
  function special(t) {
    return HOLY.test(t.building || '') || t.amenity === 'place_of_worship' || !!t.historic || !!t.religion && !!(t.name || t['name:en']) ||
           /gate|tower|dome|wall|arcade|minaret/i.test(t['name:en'] || t.name || '');
  }
  function hasHeight(t) { return t.height != null || t['building:levels'] != null || t['building:height'] != null; }
  var GREEN_IN = { grass: 1, meadow: 1, residential: 1, commercial: 1, retail: 1, religious: 1 };
  var GREEN_OUT_L = { park: 1, garden: 1, nature_reserve: 1 };
  var GREEN_OUT_U = { grass: 1, meadow: 1, village_green: 1, forest: 1, orchard: 1, vineyard: 1 };
  var GREEN_OUT_N = { wood: 1, scrub: 1, grassland: 1, heath: 1 };

  function curate(json, q) {
    var els = (json && json.elements) || [], out = [], extra = [], changed = 0;
    for (var i = 0; i < els.length; i++) {
      var e = els[i], t = e.tags || {}, c = centre(e);
      /* Buildings by their middle; lines and areas if any point is in the area, so a long road or
         rail line that only passes through is not left half in. */
      if (!c || ((t.building || t['building:part']) ? distM(c[1], c[0]) > P.areaM : !anyIn(e))) { out.push(e); continue; }
      var k = key(e);
      if (DROP[k]) { changed++; continue; }
      var inside = inWalls(c), keep = KEEP[k], fix = FIX[k];
      var isB = !!t.building, isPart = !t.building && t['building:part'] && t['building:part'] !== 'no';
      if (isB || isPart) {
        if (!inside && !keep) { changed++; continue; }
        var nt = {}, kk;
        for (kk in t) nt[kk] = t[kk];
        var add = keep || fix;
        if (add) for (kk in add) nt[kk] = add[kk];
        if (inside && !add) {
          /* Houses: one even height, whatever the map says, so the city reads as one calm mass and
             the holy places stand out. Places of worship, gates and other tagged monuments keep
             their own heights. */
          if (!isPart && !special(nt)) { nt.height = String(P.calmH); delete nt['building:levels']; delete nt['building:height']; delete nt.min_height; }
          else if (!hasHeight(nt)) nt.height = String(isPart ? P.partH : 14);
          if (nt['roof:shape'] !== 'dome' && nt['roof:shape'] !== 'onion') nt['roof:shape'] = 'flat';
        }
        var ne = {}; for (kk in e) ne[kk] = e[kk];
        ne.tags = nt;
        extra = extra.concat(domeOf(ne));
        out.push(ne); changed++;
        continue;
      }
      if (t.railway) { changed++; continue; }
      if (t.highway || t.barrier === 'hedge' || t.natural === 'tree_row') {
        if (inside) out.push(e); else changed++;
        continue;
      }
      if (t.waterway) { changed++; continue; }        /* the Kidron and Hinnom are dry: no channels */
      if (t.historic === 'citywalls' || t.barrier === 'city_wall') {
        if (!t.height) { var we = {}, wt = {}; for (kk in e) we[kk] = e[kk]; for (kk in t) wt[kk] = t[kk]; wt.height = String(P.wallH); we.tags = wt; out.push(we); changed++; }
        else out.push(e);
        continue;
      }
      if (t.barrier === 'wall' || t.barrier === 'retaining_wall') { changed++; continue; }
      if (t.natural === 'water' || t.landuse === 'reservoir' || t.landuse === 'basin') { out.push(e); continue; }
      if (t.landuse || t.natural || t.leisure) {
        if (!inside) {
          /* v1.1: the green that is really there (the walls park, Hinnom and Kidron, Mount Zion),
             woods thinned to scrub. Cemeteries, pitches and built land stay out. */
          if (P.greenOut && (GREEN_OUT_L[t.leisure] || GREEN_OUT_U[t.landuse] || GREEN_OUT_N[t.natural])) {
            if (t.landuse === 'forest' || t.natural === 'wood') {
              var ge = {}, gt = {}; for (kk in e) ge[kk] = e[kk]; for (kk in t) gt[kk] = t[kk];
              delete gt.landuse; gt.natural = 'scrub'; ge.tags = gt; out.push(ge); changed++;
            } else out.push(e);
            continue;
          }
          changed++; continue;
        }
        if (GREEN_IN[t.landuse] || t.natural === 'grassland') { out.push(e); continue; }
        changed++;
        continue;
      }
      out.push(e);
    }
    var ex = extrasFor(q);
    var res = {}; for (var rk in json) res[rk] = json[rk];
    res.elements = out.concat(extra, ex);
    if (window.console && (changed || ex.length)) {
      console.info('[mm] places: ' + P.name + ' heritage model · ' + changed + ' map shape(s) changed or left out · ' +
        (extra.length + ex.length) + ' added (domes, olive groves, tree lines)');
    }
    return res;
  }

  /* -------------------------------- fetch -------------------------------- */
  var realFetch = window.fetch.bind(window);
  var heritageUntil = 0;

  function bodyText(init) { return init && typeof init.body === 'string' ? init.body : null; }
  function overpassQuery(init) {
    var b = bodyText(init);
    if (!b || b.slice(0, 5) !== 'data=') return null;
    try { return decodeURIComponent(b.slice(5).replace(/\+/g, ' ')); } catch (e) { return null; }
  }
  function jsonResponse(obj, like) {
    return new Response(JSON.stringify(obj), {
      status: 200, statusText: 'OK',
      headers: { 'Content-Type': 'application/json' }
    });
  }
  /* "31.7780° N   35.2354° E" (the designer's Coordinates line) inside the area? */
  function inArea(cs) {
    if (!cs) return false;
    var s = String(cs), n = s.match(/\d+(?:\.\d+)?/g);
    if (!n || n.length < 2) return false;
    var la = parseFloat(n[0]) * (/\bS\b|°\s*S/.test(s) ? -1 : 1);
    var lo = parseFloat(n[1]) * (/\bW\b|°\s*W/.test(s) ? -1 : 1);
    return distM(la, lo) < P.areaM;
  }
  function urlOf(input) { return typeof input === 'string' ? input : (input && input.url) || ''; }

  /* Search: our place first, when the words fit. */
  function featureFor(kind) {
    var c = [P.frame.lon, P.frame.lat];                  /* v1.3: the exact middle of the dome */
    if (kind === 'maptiler') {
      return { type: 'Feature', id: 'mm.' + P.id, text: P.name, place_name: P.name + ', ' + P.ctx,
        place_type: ['poi'], center: c, geometry: { type: 'Point', coordinates: c },
        properties: { mm: P.id } };
    }
    return { type: 'Feature', geometry: { type: 'Point', coordinates: c },
      properties: { name: P.name, country: P.ctx, type: 'poi', osm_value: 'attraction' } };
  }
  /* v1.3: names that mean this place when they are the whole name (", Israel" allowed). */
  var EXACT = ['jerusalem', 'jerusalem old city', 'old city jerusalem', 'old city of jerusalem',
               'yerushalayim', 'al quds', 'dome of the rock', 'temple mount'];
  function normName(t) {
    return String(t || '').toLowerCase().replace(/[\u2019']/g, '').replace(/[^a-z0-9]+/g, ' ').trim()
      .replace(/ (israel|palestine)$/, '').trim();
  }
  function isOursName(t) { return EXACT.indexOf(normName(t)) >= 0; }
  /* The plain city "Jerusalem" lands 900 m west of the dome: our suggestion replaces it. */
  var CITY = ['jerusalem', 'al quds', 'yerushalayim'];
  function plainCity(nm, la, lo) { return CITY.indexOf(normName(nm)) >= 0 && isFinite(la) && isFinite(lo) && distM(la, lo) < 15000; }
  function withoutCity(kind, feats) {
    return (feats || []).filter(function (f) {
      try {
        if (kind === 'maptiler') {
          var c = f.center || (f.geometry && f.geometry.coordinates) || [];
          return !plainCity(f.text || String(f.place_name || '').split(', ')[0], +c[1], +c[0]);
        }
        var g = (f.geometry && f.geometry.coordinates) || [];
        return !plainCity(f.properties && f.properties.name, +g[1], +g[0]);
      } catch (e) { return true; }
    });
  }
  function searchText(url) {
    var m = /api\.maptiler\.com\/geocoding\/([^/?]+)\.json/.exec(url);
    if (m) {
      if (/^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/.test(decodeURIComponent(m[1]))) return null;   /* reverse lookup */
      return { kind: 'maptiler', q: decodeURIComponent(m[1]) };
    }
    m = /\/api\/?\?[^#]*[?&]q=([^&#]*)/.exec(url);
    if (m && !/nominatim/.test(url)) return { kind: 'photon', q: decodeURIComponent(m[1].replace(/\+/g, ' ')) };
    return null;
  }
  function wantsPlace(q) {
    var t = String(q || '').trim().toLowerCase().replace(/\s+/g, ' ');
    if (t.length < 3) return false;
    for (var i = 0; i < P.names.length; i++) {
      var n = P.names[i];
      if (t.indexOf(n) === 0) return true;
      if (n.indexOf(t) === 0 && t.length >= (i === 0 ? 3 : 5)) return true;
    }
    return false;
  }

  /* ---------- v1.4: towns before shops, the visitor's country first (3 Nov 2026) ---------- */
  var TOWNISH = { municipality: 1, joint_municipality: 1, joint_submunicipality: 1, municipal_district: 1,
    locality: 1, place: 1, neighbourhood: 1, postal_code: 1 };
  var DESIG = { city: 3, town: 2, village: 1, suburb: 1, quarter: 1, neighbourhood: 1, borough: 1.5,
    hamlet: 0.5, isolated_dwelling: 0.3, farm: 0.3 };
  var NEAR = ' gb ie fr de nl be lu es pt it mt at ch dk se no fi pl cz sk hu si hr ro bg gr cy ee lv lt is li ';
  function plain(t) {
    var s = String(t || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    return s.replace(/[\u2019']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function visitorCC() {
    try { return String((window.Shopify && window.Shopify.country) || '').toLowerCase(); } catch (e) { return ''; }
  }
  function ftype(f) { return ((f && f.place_type) || [])[0] || ''; }
  function fcc(f) {
    var p = (f && f.properties) || {};
    if (p.country_code) return String(p.country_code).toLowerCase();
    var c = (f && f.context) || [];
    for (var i = c.length - 1; i >= 0; i--) if (c[i] && c[i].country_code) return String(c[i].country_code).toLowerCase();
    return '';
  }
  function qParts(q) {
    var t = String(q || ''), i = t.indexOf(',');
    return { head: plain(i >= 0 ? t.slice(0, i) : t), tail: plain(i >= 0 ? t.slice(i + 1) : '') };
  }
  function nameOf(f) { return plain(f.text || String(f.place_name || '').split(', ')[0]); }
  function nameHit(f, p) {
    var n = nameOf(f), h = p.head;
    if (!n || !h) return 0;
    if (n === h) return 4;
    if (h.indexOf(n + ' ') === 0) return 3;              /* "ashford kent": the name, then more words */
    if (h.length >= 3 && n.indexOf(h) === 0) return 2;   /* still typing: "ashf" */
    return 0;
  }
  function ctxText(f) {
    var rest = String(f.place_name || '').split(', ').slice(1).join(' ');
    var c = (f.context || []).map(function (x) { return x && x.text; }).join(' ');
    return ' ' + plain(rest + ' ' + c) + ' ';
  }
  function score(f, p, cc, i) {
    var s = nameHit(f, p), t = ftype(f), pr = f.properties || {};
    var d = TOWNISH[t] ? DESIG[pr.place_designation] : null;
    if (d != null) {                                     /* a real city, town or village */
      s += d;
      var c = fcc(f);
      if (c && c === cc) s += 2.5;
      else if (c && NEAR.indexOf(' ' + c + ' ') >= 0) s += 1.5;
    } else {
      s += 0.5;                                          /* streets, landmarks, unnamed spots: MapTiler's order */
    }
    var n = nameOf(f), tail = p.tail;
    if (!tail && p.head.indexOf(n + ' ') === 0) tail = p.head.slice(n.length + 1);
    if (tail && ctxText(f).indexOf(' ' + tail + ' ') >= 0) s += 3;
    s += (+f.relevance || 0);
    return s - i * 0.01;
  }
  function rankFeatures(feats, q) {
    var p = qParts(q), cc = visitorCC(), seen = {}, out = [];
    feats.forEach(function (f, i) {
      if (!f) return;
      var c = f.center || (f.geometry && f.geometry.coordinates) || [];
      var key = f.id || (nameOf(f) + '|' + (+c[0]).toFixed(3) + '|' + (+c[1]).toFixed(3));
      if (seen[key]) return;
      seen[key] = 1;
      out.push({ f: f, s: (f.properties && f.properties.mm) ? 1e6 - i : score(f, p, cc, i) });
    });
    out.sort(function (a, b) { return b.s - a.s; });
    return out.map(function (x) { return x.f; });
  }
  function needPlaces(url, feats, q) {
    var p = qParts(q);
    if (p.head.length < 3 || !/[?&]types=[^&]*\bpoi\b/.test(url)) return false;
    /* Ask again without shops only when nothing fits: no town of that name, and no landmark or street
       called exactly that ("Central Park", "Grafton Street" stay as they are). */
    return !feats.some(function (f) {
      var t = ftype(f), h = nameHit(f, p);
      return (TOWNISH[t] && h > 0) || (h >= 3 && (t === 'poi' || t === 'address' || t === 'road'));
    });
  }
  function placesUrl(u) {
    return u.replace(/([?&]types=)([^&]*)/, function (m, a, t) {
      return a + t.split(',').filter(function (x) { return x !== 'poi'; }).join(',');
    }).replace(/([?&]limit=)\d+/, '$110');
  }
  /* Dublin is the map's starting point. Outside Ireland it is no guide: ask MapTiler to use the visitor's own area. */
  function proxFix(u) {
    var cc = visitorCC();
    if (!cc || cc === 'ie') return u;
    return u.replace(/([?&]proximity=)-6\.26(?:0+)?,53\.35(?:0+)?(?=&|$)/, '$1ip');
  }

  /* ---------- v1.5: exact addresses and postcodes without Google (3 Nov 2026) ---------- */
  var XS_MS = 1500, xsCache = {};
  var ABBR = { st: 'street', rd: 'road', ave: 'avenue', av: 'avenue', sq: 'square', ln: 'lane', dr: 'drive',
    ct: 'court', tce: 'terrace', cres: 'crescent', pk: 'park', blvd: 'boulevard', pl: 'place', gdns: 'gardens',
    gr: 'grove', cl: 'close', hwy: 'highway', mt: 'mount', nth: 'north', sth: 'south' };
  var UK_FULL = /\b([A-Z]{1,2}\d[A-Z\d]?)\s*(\d[A-Z]{2})\b/i;
  var UK_OUT = /^\s*([A-Z]{1,2}\d[A-Z\d]?)(?:\s+\d[A-Z]?)?\s*$/i;
  var EIR_DUB = /^\s*(D(?:0[1-9]|1\d|2[0-4])|D6W)(?:\s*[0-9AC-FHKNPRTV-Y]{4})?\s*$/i;
  function swap(w) { return ABBR[w] || w; }
  function addrParts(q) {
    var t = String(q || '').replace(UK_FULL, ' ').replace(/\s+,/g, ',').trim();
    var bits = t.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (bits.length > 1 && /^(flat|apt|apartment|unit|suite|no\.?)\s*[\w-]+$/i.test(bits[0])) bits.shift();
    var head = bits[0] || '', tail = plain(bits.slice(1).join(' '));
    var m1 = /^(\d+[a-z]?)[\s\/-]+(.+)$/i.exec(head), m2 = m1 ? null : /^(.+?)\s+(\d+[a-z]?)$/i.exec(head);
    if (!m1 && !m2) return null;
    var hn = m1 ? m1[1] : m2[2], st = m1 ? m1[2] : m2[1];
    var words = plain(st).split(' ').filter(Boolean).map(swap);
    if (!words.length || plain(st).length < 3 || /^\d+$/.test(plain(st))) return null;
    return { hn: plain(hn), words: words, tail: tail, numFirst: !!m1 };
  }
  function streetHit(words, s) {
    var toks = plain(s).split(' ').filter(Boolean).map(swap);
    return words.every(function (w) {
      return toks.some(function (k) { return k === w || (w.length >= 2 && k.indexOf(w) === 0); });
    });
  }
  function addrScore(hn, street, where, cc, a, i) {
    if (plain(hn) !== a.hn || !streetHit(a.words, street)) return -1;
    var s = 10 - i * 0.1, vc = visitorCC();
    var tw = a.tail ? a.tail.split(' ')[0] : '';
    if (tw.length >= 3 && (' ' + plain(where) + ' ').indexOf(' ' + tw) >= 0) s += 3;
    if (cc && cc === vc) s += 2;
    else if (cc && NEAR.indexOf(' ' + cc + ' ') >= 0) s += 1;
    return s;
  }
  function xFeature(id, name, ctx, lon, lat, type, cc, src) {
    var c = [+lon, +lat];
    return { type: 'Feature', id: 'mmx.' + id, text: name, place_name: ctx ? name + ', ' + ctx : name,
      place_type: [type], relevance: 1, center: c, geometry: { type: 'Point', coordinates: c },
      properties: { country_code: cc || '', mmsrc: src } };
  }
  function xJson(u, sig, ms) {
    var c = ('AbortController' in window) ? new AbortController() : null, tid = null;
    if (c) {
      tid = setTimeout(function () { c.abort(); }, ms || XS_MS);
      if (sig) { if (sig.aborted) c.abort(); else sig.addEventListener('abort', function () { c.abort(); }); }
    }
    return realFetch(u, c ? { signal: c.signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { clearTimeout(tid); return j; }, function () { clearTimeout(tid); return null; });
  }
  function uniq(list) { return list.filter(function (x, k) { return x && list.indexOf(x) === k; }); }
  /* Photon: the best exact house for the number and street typed. */
  function photonHouse(t, a, sig) {
    return xJson('https://photon.komoot.io/api/?limit=8&lang=en&q=' + encodeURIComponent(t), sig).then(function (j) {
      var best = null, bs = -1;
      ((j && j.features) || []).forEach(function (f, i) {
        var p = f.properties || {}, g = (f.geometry || {}).coordinates || [];
        if (!p.housenumber || !isFinite(g[0]) || !isFinite(g[1])) return;
        var cc = String(p.countrycode || '').toLowerCase();
        var s = addrScore(p.housenumber, p.street || p.name || '',
          [p.district, p.locality, p.city, p.county, p.state, p.postcode, p.country].join(' '), cc, a, i);
        if (s > bs) { bs = s; best = { p: p, g: g, cc: cc, s: s }; }
      });
      if (!best) return null;
      var p = best.p, st = p.street || p.name;
      var f = xFeature('ph' + (p.osm_id || Math.round(best.g[0] * 1e5)), a.numFirst ? p.housenumber + ' ' + st : st + ' ' + p.housenumber,
        uniq([p.district || p.locality, p.city, p.postcode, p.country]).join(', '), best.g[0], best.g[1], 'address', best.cc, 'photon');
      f.__s = best.s;
      return f;
    });
  }
  /* MapTiler's own best exact house, scored the same way. */
  function mtHouse(feats, a) {
    var best = null, bs = -1;
    feats.forEach(function (f, i) {
      if (ftype(f) !== 'address') return;
      var parts = String(f.place_name || '').split(', '), first = parts[0] || '';
      var m = /^(\d+[a-z]?)\s+(.+)$/i.exec(first) || /^(.+?)\s+(\d+[a-z]?)$/i.exec(first);
      if (!m) return;
      var hn = /^\d/.test(m[1]) ? m[1] : m[2], st = /^\d/.test(m[1]) ? m[2] : m[1];
      var s = addrScore(hn, st, parts.slice(1).join(' ') + ' ' + ctxText(f), fcc(f), a, i);
      if (s > bs) { bs = s; best = f; }
    });
    if (best) best.__s = bs;
    return best;
  }
  function ukFull(code, head, sig) {
    return xJson('https://api.postcodes.io/postcodes/' + encodeURIComponent(code), sig).then(function (j) {
      var r = j && j.result;
      if (!r || r.latitude == null) return null;
      var own = head && plain(head) !== plain(r.postcode);
      return xFeature('pc' + plain(r.postcode).replace(/ /g, ''), own ? head : r.postcode,
        uniq([r.admin_ward, r.admin_district, own ? r.postcode : null, 'United Kingdom']).join(', '),
        r.longitude, r.latitude, own ? 'address' : 'postal_code', 'gb', 'postcodes');
    });
  }
  function ukOut(oc, sig) {
    return xJson('https://api.postcodes.io/outcodes/' + encodeURIComponent(oc), sig).then(function (j) {
      var r = j && j.result;
      if (!r || r.latitude == null) return null;
      return xFeature('oc' + plain(oc), String(r.outcode || oc).toUpperCase(),
        uniq([[].concat(r.admin_district || []).slice(0, 2).join(' / '), [].concat(r.country || [])[0], 'United Kingdom']).join(', '),
        r.longitude, r.latitude, 'postal_code', 'gb', 'postcodes');
    });
  }
  function dubDistrict(key, typed, url, sig) {
    var n = key.toUpperCase() === 'D6W' ? '6W' : String(parseInt(key.slice(1), 10));
    var u = url.replace(/(geocoding\/)[^/?]+(\.json)/, '$1' + encodeURIComponent('Dublin ' + n) + '$2')
      .replace(/([?&]types=)[^&]*/, '$1place,neighbourhood,locality,postal_code')
      .replace(/([?&]limit=)\d+/, '$13').replace(/([?&]autocomplete=)true/, '$1false');
    return xJson(u, sig).then(function (j) {
      var f = ((j && j.features) || []).filter(function (x) { return fcc(x) === 'ie' || /Ireland/.test(x.place_name || ''); })[0];
      if (!f) return null;
      var c = f.center || (f.geometry && f.geometry.coordinates);
      return xFeature('eir' + key.toLowerCase(), 'Dublin ' + n, 'Eircode area ' + String(typed).toUpperCase().replace(/\s+/g, ' ').trim() + ', Ireland',
        c[0], c[1], 'place', 'ie', 'eircode');
    });
  }
  function qKind(t) {
    if (EIR_DUB.test(t)) return 'eir';
    if (UK_FULL.test(t)) return addrParts(t) ? 'addrpc' : 'pc';
    if (UK_OUT.test(t)) return 'out';
    return addrParts(t) ? 'addr' : 'place';
  }
  /* Promise of [house, postcode/area] features to put above MapTiler's list (nulls dropped). */
  function extrasFor2(q, url, sig) {
    var t = String(q || '').trim();
    if (window.MM_XS_OFF || t.length < 2) return Promise.resolve({ house: null, area: null });
    var key = t.toLowerCase();
    if (xsCache[key]) return xsCache[key];
    var m, area = Promise.resolve(null), house = Promise.resolve(null), a = addrParts(t);
    if ((m = EIR_DUB.exec(t))) area = dubDistrict(m[1], t, url, sig);
    else if ((m = UK_FULL.exec(t))) {
      var head = t.slice(0, m.index).replace(/[\s,]+$/, '').split(',')[0].trim();
      area = ukFull(m[1] + ' ' + m[2], head.length >= 3 ? head : '', sig);
    } else if ((m = UK_OUT.exec(t)) && !/^\d/.test(t)) area = ukOut(m[1], sig);
    if (a && t.length >= 8) house = photonHouse(t, a, sig);
    var p = Promise.all([house, area]).then(function (r) { return { house: r[0], area: r[1], a: a }; });
    xsCache[key] = p;
    p.then(function (r) { if (!r.house && !r.area) delete xsCache[key]; });
    return p;
  }
  function nearM(f1, f2, m) {
    var a = f1.center || (f1.geometry && f1.geometry.coordinates) || [], b = f2.center || (f2.geometry && f2.geometry.coordinates) || [];
    if (!isFinite(a[0]) || !isFinite(b[0])) return false;
    var x = (b[0] - a[0]) * D2R * Math.cos((a[1] + b[1]) / 2 * D2R), y = (b[1] - a[1]) * D2R;
    return Math.sqrt(x * x + y * y) * 6371000 < m;
  }
  /* MapTiler's ranked list with the extras merged in. */
  function mergeExtras(ranked, xs, q) {
    var top = [], t = String(q || '').trim(), kind = qKind(t);
    if (xs.house) {
      var mine = xs.a ? mtHouse(ranked, xs.a) : null;
      if (!mine || xs.house.__s > mine.__s || (ranked[0] !== mine && !nearM(mine, xs.house, 75))) top.push(xs.house);
      if (mine && !nearM(mine, xs.house, 75) && top.length) top.push(mine);
      else if (mine && !top.length) top.push(mine);
    }
    if (xs.area) {
      if (kind === 'pc' || kind === 'out' || kind === 'eir' || !top.length) top.unshift(xs.area);
      else top.push(xs.area);
    }
    if (!top.length) return ranked;
    var rest = ranked.filter(function (f) { return top.indexOf(f) < 0 && !top.some(function (x) { return nearM(x, f, 40) && (ftype(x) === ftype(f) || nameOf(x) === nameOf(f)); }); });
    return top.concat(rest);
  }

  /* Anonymous log of backup searches: kind, source, position, and a map drag after the pick. */
  var MLOG = 'https://mm-steps.kissmycans.workers.dev/in';   /* the hub's step counter, never the mailer (note 3 Nov 18:26) */
  var lastList = null;
  function mlog(ev) {
    try {
      var path = location.pathname;
      var body = JSON.stringify({ action: 'funnel', v: 1, id: 'ms' + Math.random().toString(36).slice(2, 12).replace(/[^a-z0-9]/g, 'x'),
        n: 0, page: 'msearch', land: path === '/' ? 'home' : /^\/pages\/configurator/.test(path) ? 'cfg' : 'other', src: '',
        dev: ((window.matchMedia && matchMedia('(pointer:coarse)').matches) || innerWidth < 768) ? 'mobile' : 'desktop',
        cc: visitorCC().toUpperCase().slice(0, 2), secs: Math.round(performance.now() / 1000),
        ev: 'msearch@' + ev, size: '', gen: 0, err: 0, b: 'places-1.5' });
      if (navigator.sendBeacon) navigator.sendBeacon(MLOG, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
    } catch (e) {}
  }
  document.addEventListener('click', function (ev) {
    try {
      var it = ev.target && ev.target.closest && ev.target.closest('.mm-sugg-item, .mmf-sugg__item');
      if (!it || !lastList || Date.now() - lastList.at > 120000) return;
      var all = Array.prototype.slice.call(it.parentNode.querySelectorAll('.mm-sugg-item, .mmf-sugg__item'));
      var i = all.indexOf(it), f = lastList.feats[i];
      var src = (f && f.properties && f.properties.mmsrc) || 'mt';
      var tag = lastList.kind + '-' + src + '-' + (i + 1);
      mlog('pick-' + tag);
      try { sessionStorage.setItem('mmMsPick', JSON.stringify({ tag: tag, at: Date.now() })); } catch (e) {}
    } catch (e) {}
  }, true);
  document.addEventListener('pointerdown', function (ev) {
    try {
      if (!ev.target || !ev.target.closest || !ev.target.closest('.maplibregl-canvas-container, .maplibregl-canvas')) return;
      var pk = JSON.parse(sessionStorage.getItem('mmMsPick') || 'null');
      if (!pk || Date.now() - pk.at > 300000) return;
      sessionStorage.removeItem('mmMsPick');
      mlog('drag-' + pk.tag);
    } catch (e) {}
  }, true);
  function rankedSearch(input, init, q) {
    var orig = urlOf(input), url = proxFix(orig);
    var lim = +((/[?&]limit=(\d+)/.exec(url) || [])[1]) || 6;
    var sig = (init && init.signal) ? { signal: init.signal } : undefined;
    var xs = extrasFor2(q, url, init && init.signal);              /* v1.5: asked at the same time */
    return realFetch(url === orig ? input : url, init).then(function (r) {
      if (!r.ok) return r;
      return r.clone().json().then(function (j) {
        var feats = (j && j.features) || [];
        var more = needPlaces(url, feats, q)
          ? realFetch(placesUrl(url), sig).then(function (r2) { return r2.ok ? r2.json() : null; })
              .then(function (j2) { return (j2 && j2.features) || []; },
                    function (e) { if (e && e.name === 'AbortError') throw e; return []; })
          : Promise.resolve([]);
        return Promise.all([more, xs.catch(function () { return {}; })]).then(function (res) {
          var o = {}; for (var k in (j || {})) o[k] = j[k];
          var list = rankFeatures(feats.concat(res[0]), q);
          try { list = mergeExtras(list, res[1] || {}, q); } catch (eX) {}
          o.features = list.slice(0, lim);
          lastList = { at: Date.now(), kind: qKind(String(q || '').trim()), feats: o.features };
          return jsonResponse(o, r);
        });
      }, function () { return r; });
    });
  }

  window.fetch = function (input, init) {
    var url = urlOf(input);
    try {
      /* 1. Map data for the area: rewrite the answer. */
      var q = overpassQuery(init);
      if (q && q.indexOf('[out:json]') === 0) {
        var b = bboxOf(q);
        if (b && boxNearArea(b)) {
          if (/way\["building"\]/.test(q)) {
            var mid = distM((b.s + b.n) / 2, (b.w + b.e) / 2);
            if (mid < P.areaM + 400) heritageUntil = Date.now() + 240000;
          }
          return realFetch(input, init).then(function (r) {
            if (!r.ok) return r;
            return r.clone().json().then(function (j) {
              return jsonResponse(curate(j, q), r);
            }, function () { return r; });
          });
        }
      }
      /* 2. Overture would put modern buildings back: not asked while the area is being built. */
      if (/overturemaps/.test(url) && Date.now() < heritageUntil) {
        return Promise.reject(new TypeError('places: Overture not used for ' + P.name));
      }
      /* 3. Land cover (built-up) for the area: none. */
      var lc = /worldcover[^?]*\/sample\?bbox=(-?[\d.]+),(-?[\d.]+),(-?[\d.]+),(-?[\d.]+)/.exec(url);
      if (lc && distM((+lc[2] + +lc[4]) / 2, (+lc[1] + +lc[3]) / 2) < P.areaM) {
        return Promise.resolve(new Response('{"error":"places"}', { status: 503, headers: { 'Content-Type': 'application/json' } }));
      }
      /* 4. Search suggestions. */
      var s = searchText(url);
      if (s && wantsPlace(s.q)) {
        return realFetch(input, init).then(function (r) {
          return r.clone().json().then(function (j) {
            var o = {}; for (var k2 in (j || {})) o[k2] = j[k2];
            o.features = [featureFor(s.kind)].concat(withoutCity(s.kind, j && j.features));
            return jsonResponse(o, r);
          }, function () { return r; });
        }, function () {
          return jsonResponse({ type: 'FeatureCollection', features: [featureFor(s.kind)] });
        });
      }
      /* 4b. v1.4: towns before shops, the visitor's own country first. */
      if (s && s.kind === 'maptiler' && !window.MM_RANK_OFF) return rankedSearch(input, init, s.q);
      /* 5. Cart: say which edition, so the print is made from our file. */
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
        if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
          if (inArea(init.body.get('properties[Coordinates]')) && !init.body.has('properties[Edition]')) {
            init.body.append('properties[Edition]', P.edition);
          }
        } else if (bodyText(init) && bodyText(init).charAt(0) === '{') {
          var body = JSON.parse(bodyText(init)), hit = false;
          (body.items || [body]).forEach(function (it) {
            var pr = it && it.properties;
            if (pr && inArea(pr.Coordinates)) { pr.Edition = P.edition; hit = true; }
          });
          if (hit) {
            var ni = {}; for (var k3 in init) ni[k3] = init[k3];
            ni.body = JSON.stringify(body);
            return realFetch(input, ni);
          }
        }
      }
    } catch (err) {
      if (window.console) console.warn('[mm] places: passed through after an error', err && err.message);
    }
    return realFetch(input, init);
  };

  /* --------- choosing the suggestion opens the framed 40 cm model --------- */
  /* The designer has no outside way to set size and zoom, but it reads a saved-model link
     (?mm=...) on load, so the suggestion opens that link: 40 cm, framed on the walls. */
  /* v1.3: ?mm= sets 40 cm and the centre; ?mmq=&mmn= is the designer's homepage hand-off (lands on
     the point, keeps the name, brings the map into view, then comes off the address bar). */
  var CFG_RE = /\/pages\/configurator\/?$/;
  function frameUrl() {
    var o = { c: P.sizeCm, z: P.frame.zoom, a: P.frame.lat, o: P.frame.lon, n: P.name };
    var tok = btoa(unescape(encodeURIComponent(JSON.stringify(o)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    var onCfg = CFG_RE.test(location.pathname);
    var rest = onCfg ? String(location.search || '').replace(/^\?/, '').split('&').filter(function (kv) {
      return kv && !/^(mm|mmq|mmn|mmnew)(=|$)/.test(kv);
    }) : [];
    return (onCfg ? location.pathname : '/pages/configurator') + '?' +
      ['mm=' + tok, 'mmq=' + P.frame.lat + '%2C' + P.frame.lon, 'mmn=' + encodeURIComponent(P.name)].concat(rest).join('&');
  }
  /* v1.3: arriving at the designer for Jerusalem from anywhere (homepage pick, its Recent list,
     Enter, a typed ?mmq=Jerusalem): rewrite the address before the designer reads it. This file
     loads before the designer, so no reload. */
  (function handoff() {
    try {
      if (!CFG_RE.test(location.pathname) || !history.replaceState) return;
      if (/[?&#]mm=/.test(location.href)) return;
      var s = String(location.search || ''), mq = /[?&]mmq=([^&#]*)/.exec(s);
      if (!mq) return;
      var dec = function (v) { try { return decodeURIComponent(v.replace(/\+/g, ' ')).trim(); } catch (e) { return ''; } };
      var q = dec(mq[1]), mn = /[?&]mmn=([^&#]*)/.exec(s), n = mn ? dec(mn[1]) : '';
      var c = /^(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)$/.exec(q);
      var hit = c ? ((isOursName(n) || normName(n) === 'old city') && distM(+c[1], +c[2]) < 15000) : isOursName(q);
      if (!hit) return;
      history.replaceState(history.state, '', frameUrl() + location.hash);
      if (window.console) console.info('[mm] places: "' + (n || q) + '" opens the ' + P.name + ' model, 40 cm, centred on the Dome of the Rock');
    } catch (eH) {}
  })();
  function ours(it) { return !!(it && it.textContent && it.textContent.indexOf(P.name) === 0); }
  function go(ev) {
    ev.preventDefault(); ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    location.href = frameUrl();
  }
  document.addEventListener('click', function (ev) {
    var it = ev.target && ev.target.closest && ev.target.closest('.mm-sugg-item');
    if (ours(it)) go(ev);
  }, true);
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || !ev.target || !ev.target.classList || !ev.target.classList.contains('mm-search-input')) return;
    var list = document.querySelector('.mm-sugg-list:not(.mm-hide)');
    if (!list) return;
    var items = list.querySelectorAll('.mm-sugg-item'), act = null;
    for (var i = 0; i < items.length; i++) if (/is-active|active/.test(items[i].className)) act = items[i];
    if (ours(act || items[0])) go(ev);
  }, true);
  /* v1.3: Enter on "Jerusalem" before the list has appeared. */
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || !ev.target || !ev.target.classList || !ev.target.classList.contains('mm-search-input')) return;
    var list = document.querySelector('.mm-sugg-list:not(.mm-hide)');
    if (list && list.querySelector('.mm-sugg-item')) return;
    if (isOursName(ev.target.value)) go(ev);
  }, true);

  window.MM_PLACES = { place: P, curate: curate, inWalls: inWalls, frameUrl: frameUrl, isOursName: isOursName, rank: rankFeatures, addrParts: addrParts, qKind: qKind, version: 'v1.5' };
})();
